import React, { ReactNode } from 'react';

import { Tooltip as TooltipCore, TooltipProps as ITooltipProps } from 'antd';

import styles from './Tooltip.module.scss';

const Tooltip = (
	props: Omit<ITooltipProps, 'title'> & { title: ReactNode },
) => {
	const { children = null, title, placement = 'top', ...restProps } = props;
	return (
		<TooltipCore
			title={title ? <div className={styles.titleWrapper}>{title}</div> : ''}
			autoAdjustOverflow={false}
			destroyTooltipOnHide
			getTooltipContainer={(node) => node?.parentElement as HTMLElement}
			placement={placement}
			{...restProps}
		>
			{children}
		</TooltipCore>
	);
};

export default Tooltip;
